import {httpClient} from './httpClient';

const END_POINT = '/budget/';

const getAllBudgets = (params = {}) => httpClient.get(END_POINT, { params });

const getBudget = (budget_id) => httpClient.get(END_POINT + budget_id + "/");

export {
    getAllBudgets, getBudget
}
